import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { DTOProfileCard as UserProfile } from 'src/apis/dto/DTOProfileCard';
import CopyIconBase from 'src/assets/images/icCopyBold.svg';
import Gap from 'src/components/Gap';
import { showCommonErrorToastAtom, showToastAtom } from 'src/stores/toast/atoms';
import { ToastType } from 'src/types/Toast';
import { copyToClipboard } from 'src/utils/common';
const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  padding: 4px 6px;
  background-color: ${({
  theme
}) => theme.color.surface4};
  border-radius: 6px;
`;
const Text = styled.span`
  font-weight: 400;
  font-size: 10px;
  line-height: 13px;
  color: ${({
  theme
}) => theme.color.content8};
`;
const BoldText = styled(Text)`
  font-weight: 700;
`;
const CopyButton = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
`;
const CopyIcon = styled(CopyIconBase)`
  width: 8px;
  height: 8px;
  color: ${({
  theme
}) => theme.color.content8};
`;
interface Props {
  profile: UserProfile;
  className?: string;
}
const UserCode = ({
  profile,
  className
}: Props) => {
  const {
    userCode
  } = profile;
  const showToast = useSetAtom(showToastAtom);
  const showCommonErrorToast = useSetAtom(showCommonErrorToastAtom);
  const handleClickCopy = () => {
    if (!userCode) {
      return;
    }
    copyToClipboard(userCode).then(result => {
      if (result) {
        showToast({
          type: ToastType.SUCCESS,
          message: 'common.toast_code_copied'
        });
      } else {
        showCommonErrorToast();
      }
    });
  };
  return <Wrap className={className} data-sentry-element="Wrap" data-sentry-component="UserCode" data-sentry-source-file="index.tsx">
      <BoldText data-sentry-element="BoldText" data-sentry-source-file="index.tsx">Code</BoldText>
      <Gap width={8} data-sentry-element="Gap" data-sentry-source-file="index.tsx" />
      <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">{userCode}</Text>
      <Gap width={4} data-sentry-element="Gap" data-sentry-source-file="index.tsx" />
      <CopyButton onClick={handleClickCopy} data-sentry-element="CopyButton" data-sentry-source-file="index.tsx">
        <CopyIcon data-sentry-element="CopyIcon" data-sentry-source-file="index.tsx" />
      </CopyButton>
    </Wrap>;
};
export default UserCode;